import type { ApiClient } from "@/lib/api";
import { getHttpErrorFields, isHttpError } from "@/lib/http-error";

export type IssuerCheckResult = { ok: true } | { ok: false; message: string };

/**
 * Validate an OIDC issuer against the coordinator without persisting anything.
 *
 * A rejected issuer (HTTP 422) is a normal outcome, not a failure, so it is
 * returned as `{ ok: false }` with the operator-facing reason. Every other
 * failure — endpoint absent (404/405), coordinator down, network blip — throws,
 * letting the caller degrade silently rather than flag a reachable issuer as
 * broken. The endpoint returns 204 with no body on success.
 */
export const testIssuer = async ({
  client,
  issuer,
}: {
  client: ApiClient;
  issuer: string;
}): Promise<IssuerCheckResult> => {
  try {
    await client.post("/user_sources/test_issuer", { issuer });
    return { ok: true };
  } catch (error) {
    if (isHttpError(error) && error.status === 422) {
      return { ok: false, message: getHttpErrorFields(error).message };
    }
    throw error;
  }
};
